import styled from 'styled-components';

export const MarginTop12px = styled.div`
    margin-top: 12px;
`;

export const MarginTop16px = styled.div`
    margin-top: 16px;
`;
